import createReactClass from 'create-react-class';
('use strict');

// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
// Import JS Modules
import GenericPaginatedUploadMixin from './loader-mixins/generic-paginated-upload-mixin';
import UploadAnalytics from './upload-analytics';
import { builderDispatch, PrismUI, WebUI } from '../_utils/ui';
import FileClearingMixin from './loader-mixins/file-clearing-mixin';
import FileSelectorMixin from './loader-mixins/file-selector-mixin';
import UploadButton from './utils/upload-button';
import AlbumSelector from './album-selector';
import CustomText from './custom-text';
import ImageUploadFileValidator from '../_utils/image-upload-file-validator';
import AnalyticsHandler from '../_libs/analytics/checkout-google-analytics';
import sendToGoogleAnalytics from '../_prism-builder/desktop/slot-tools/send-to-google-analytics';
import { db } from '../_utils/db/db';
import { uploadUrl } from '../_prism-builder/desktop/lib/add-photos-interface';
import { compressImage } from '../_utils/db/image-manip-helpers';
import heic2any from 'heic2any';
import { usePrismItemStore } from 'stores/usePrismItemStore';
import * as pdfjsLib from "pdfjs-dist";
import readFileAsArrayBuffer from '../_utils/readFileAsArrayBuffer';

const LocalFileImportIndexedDB = createReactClass({
  mixins: [GenericPaginatedUploadMixin, FileSelectorMixin, FileClearingMixin],
  displayName: 'Local file import native',

  getInitialState() {
    const { App } = window;
    this.files = this.files || [];

    return {
      loggedIn: App && App.order.logged_in(),
    };
  },
  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      if (payload.type === WebUI.LOGIN) {
        this.setState({
          loggedIn: true,
        });
      }
    });
    const component = ReactDOM.findDOMNode(this);
    component.addEventListener('dragover', this.handleDragOver, false);
    component.addEventListener('dragenter', this.handleDragEnter, false);
    component.addEventListener('dragleave', this.handleDragLeave, false);
    component.addEventListener('drop', this.handleDrop, false);
  },
  componentWillUnmount() {
    const component = ReactDOM.findDOMNode(this);
    component.removeEventListener('dragover', this.handleDragOver, false);
    component.removeEventListener('dragenter', this.handleDragEnter, false);
    component.removeEventListener('dragleave', this.handleDragLeave, false);
    component.removeEventListener('drop', this.handleDrop, false);
  },
  sendAnalytics(eventCategory) {
    const eventLabel = UploadAnalytics.eventTypes(
      this.files.map(f => f.uploadAnalytics)
    );

    const payload = {
      type: WebUI.Analytics.SEND,
      eventCategory: eventCategory,
      eventAction: 'device',
      eventLabel: eventLabel,
      eventValue: this.files.length,
    };

    AnalyticsHandler.handleAnalyticsEvent(payload);
  },

  render() {
    return (
      <div
        id={'image-loader-service-' + this.props.service}
        style={{ height: this.props.height }}
        className={classNames(
          'text-center image-loader-service',
          this.props.service,
          { 'd-none': !this.props.isActive }
        )}
        tabIndex="0">
        <div className="d-flex d-md-none h-100 flex-column justify-content-center">
          <i className="d-none d-lg-block large fas fa-laptop" />
          <i className="mx-auto d-lg-none large fas fa-mobile-alt" />
          <h3 className="title service-title font-weight-bold">My Phone</h3>
          <small>Upload photos from your phone.</small>
          <div className="mobile-file-upload-btn">
            <UploadButton
              label="Upload"
              ariaLabel="Upload"
              onChange={this.handleFileInputChange}
              fileValidator={this.props.fileValidator}
            />
          </div>
          <CustomText
            textKey="imageLoaderLocalFileImportBannerHtml"
            className="local-file-import-banner local-file-import-banner-mweb d-none"
          />
        </div>
        <div id="fileList" />
        <div
          id="dropArea"
          data-test-id="dropArea" // For testing purposes
          className="d-none d-md-flex h-100 flex-column justify-content-center align-items-center">
          <div className="album-selector-box d-none">
            <div className="image-loader-form-elements">
              {!!this.state.loggedIn && (
                <AlbumSelector
                  targetAlbum={this.props.targetAlbum}
                  onAlbumSelected={this.handleTargetAlbumSelected}
                />
              )}
            </div>
          </div>
          <div className="device">
            <i className="large fas fa-cloud-upload-alt" />
            <h3 className="title font-weight-bold">Drag &amp; Drop Here</h3>
            <small className="d-block">
              * Upload jpeg, jpg, png, pdf, heic, heif or avif image formats.
            </small>
            <UploadButton
              label="Upload Photos"
              ariaLabel="Upload"
              onChange={this.handleFileInputChange}
              fileValidator={this.props.fileValidator}
            />
          </div>
        </div>
      </div>
    );
  },

  handleTargetAlbumSelected(album) {
    if (this.props.onTargetAlbumSelected)
      this.props.onTargetAlbumSelected(album);
  },

  draggable() {
    return (
      'draggable' in document.createElement('span') && !this.props.isMobile
    );
  },

  handleDragOver(e) {
    e.stopPropagation();
    e.preventDefault();
  },

  dragCounter: 0,
  handleDragEnter(e) {
    e.preventDefault();

    if (this.dragCounter++ === 0) $('#dropArea').addClass('dragover');
  },

  handleDragLeave(e) {
    if (--this.dragCounter === 0) $('#dropArea').removeClass('dragover');
  },

  handleDrop(e) {
    e.preventDefault();

    this.dragCounter = 0;
    $('#dropArea').removeClass('dragover');

    const files = Array.prototype.slice.apply(e.dataTransfer.files);
    this.addFiles(files);
    return false;
  },

  triggerFeatureTracking() {
    sendToGoogleAnalytics('offline-local-import', '');
  },

  handleFileInputChange(e) {
    this.triggerFeatureTracking();
    const $fileInput = e.target;
    const files = Array.from($fileInput.files);

    if (!files.length) return;

    this.addFiles(files);
    $fileInput.value = '';
  },

  async addFiles(files) {
    const filteredFiles = files.filter(
      this.props.fileValidator.isAcceptedFileType
    );

    if (filteredFiles.length > 0) {
      builderDispatch.dispatch({
        type: WebUI.UPLOAD_BEGUN,
        number_of_files: filteredFiles.length,
      });

      usePrismItemStore.setState(({ imagesUploadProgress }) => ({
        imagesUploadProgress: {
          current: 1,
          totalFiles: filteredFiles.length,
        },
      }));

      builderDispatch.dispatch({
        type: PrismUI.CLOSE_ADD_PHOTOS_MODAL,
      });

      for (let uncompressedImageFile of filteredFiles) {
        try {
          if (uncompressedImageFile.type === 'application/pdf') {
            await processPDF(uncompressedImageFile);
          } else {
            await processImage(uncompressedImageFile);
          }
        } catch (error) {
          dispatchAndDisplayFailedUpload(uncompressedImageFile.name);
          console.error('Error processing file:', error);
        }
      }
    }
  },
  _buildFormData() {
    return false;
  },
});

LocalFileImportIndexedDB.defaultProps = {
  fileValidator: new ImageUploadFileValidator(),
};

const processFileAndUpload = async (uncompressedImageFile, processedFile) => {
  const compressedImageForThumbnails = await compressImage(
    processedFile || uncompressedImageFile,
    { maxWidthOrHeight: 512 }
  );

  const fileToUpload = processedFile || uncompressedImageFile;

  const fileData = {
    file: fileToUpload,
    compressedImage: compressedImageForThumbnails,
    status: 'pending',
    uploadUrl: uploadUrl(),
    prismItemID: prismItem.num,
  };

  await db.upload.add(fileData);
  return fileData;
};

const convertHEICIfNeeded = async (uncompressedImageFile) => {
  if (uncompressedImageFile.type === 'image/heic' || uncompressedImageFile.type === 'image/heif') {
    const convertedBlob = await heic2any({
      blob: uncompressedImageFile,
      toType: 'image/jpeg',
      quality: 1,
    });
    return new File([convertedBlob], `${uncompressedImageFile.name}.jpg`, {
      type: 'image/jpeg',
    });
  }
  return uncompressedImageFile;
};

const processPDF = async (uncompressedImageFile) => {
  const pdfData = await readFileAsArrayBuffer(uncompressedImageFile);

  try {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

    const pdfDoc = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const numPages = pdfDoc.numPages;

    builderDispatch.dispatch({
      type: WebUI.UPLOAD_BEGUN,
      number_of_files: numPages,
    });

    usePrismItemStore.setState(({ imagesUploadProgress }) => ({
      imagesUploadProgress: {
        current: 1,
        totalFiles: numPages,
      },
    }));

    sendToGoogleAnalytics('pdf-upload', numPages);

    const canvasPDF = document.createElement('canvas');
    canvasPDF.style.display = 'none';
    document.body.appendChild(canvasPDF);
    const ctx = canvasPDF.getContext('2d');

    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdfDoc.getPage(pageNum);
      const viewport = page.getViewport({ scale: 2 });

      canvasPDF.width = viewport.width;
      canvasPDF.height = viewport.height;

      await page.render({
        canvasContext: ctx,
        viewport: viewport,
        background: 'rgba(0,0,0,0)',
      }).promise;

      const blob = await new Promise((resolve) => canvasPDF.toBlob(resolve, 'image/png'));
      const fileName = `${uncompressedImageFile.name}-${pageNum}.png`;
      const newFile = new File([blob], fileName, { type: 'image/png' });

      await processFileAndUpload(uncompressedImageFile, newFile);
    }
    document.body.removeChild(canvasPDF);
  } catch (error) {
    dispatchAndDisplayFailedUpload(uncompressedImageFile.name);
    console.error('Error processing PDF:', error);
  }
};

const dispatchAndDisplayFailedUpload = (fileName) => {
  builderDispatch.dispatch({
    type: WebUI.UPLOAD_PROGRESS,
  });

  usePrismItemStore.getState().trackProgress();

  usePrismItemStore.setState(({ failedImagesUploaded }) => ({
    failedImagesUploaded: [...failedImagesUploaded, fileName],
  }));

}

const processImage = async (uncompressedImageFile) => {
  const convertedFile = await convertHEICIfNeeded(uncompressedImageFile);
  await processFileAndUpload(uncompressedImageFile, convertedFile);
};

export default LocalFileImportIndexedDB;
